import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'fileSize',
    standalone: true
})
export class FileSizePipe implements PipeTransform {
    transform(value: number): string {
        let sizeValue = 'Bytes';

        if (value >= 1000000) {
            sizeValue = 'MB';
            value = value / 1000000;
        } else if (value >= 1000) {
            sizeValue = 'KB';
            value = value / 1000;
        }

        return value ? `${value.toFixed(2)} ${sizeValue}` : '';
    }
}
